import { tulkaLanguages} from '../i18n';

const improvements = {
  'feedback:improvement:1:tech:bad_connection': {
    en: 'Bad connection',
    fi:	'Huono yhteys',
    sv:	'Dålig anslutning',
    no:	'Dårlig forbindelse',
    da:	'Dårlig forbindelse',
    fr:	'Mauvaise connexion'
  },
  'feedback:improvement:2:tech:connection_dropped':	{
    en: 'Connection dropped',
    fi:	'Yhteys katkesi',
    sv:	'Anslutning avbruten',	
    no: 'Tilkobling tapt',
    da:	'Forbindelsen blev afbrudt',
    fr:	'Connexion interrompue'
  },
  'feedback:improvement:3:tech:app_was_slow': {
    en: 'App was slow',
    fi:	'Sovellus hidasteli',
    sv: 'Appen var långsam.',
    no:	'Appen var treg.',
    da:	'Appen var langsom',
    fr:	'L\'application était lente'
  },
  'feedback:improvement:4:interpretation:interpreter_does_not_introduce': {
    en: 'Interpreter doesn\'t introduce themselves',
    fi:	'Tulkki ei esittäydy',
    sv:	'Tolken presenterar sig inte',
    no:	'Tolk introduserer seg ikke',
    da:	'Tolk præsentere sig ikke',
    fr:	'L\'interprète ne se présente pas'
  },
  'feedback:improvement:5:interpretation:interpreter_was_in_poor_location': {
    en: 'Interpreter in poor location',
    fi: 'Tulkki huonossa paikassa',
    sv:	'Tolk i dålig plats',
    no:	'Tolk i dårlig beliggenhet',
    da:	'Tolk i dårlig placering',
    fr:	'Interprète mal placé'
  },
  'feedback:improvement:6:interpretation:interpreter_does_not_tell_limited_time': {
    en: 'Interpreter doesn’t mention time limitations',
    fi:	'Tulkki ei ilmoittanut ajan rajallisuudesta',
    sv:	'Tolken nämner inte tidsbegränsningar',
    no:	'Tolk nevner ikke tidsbegrensninger',
    da:	'Tolk nævner ikke tidsbegrænsninger',
    fr:	'L\'interprète ne mentionne pas les limites de temps'
  },
  'feedback:improvement:prebooking:1:interpretation:interpreter_did_not_answer_or_arrive': {
    en: 'Interpreter did not answer/arrive',
    fi:	'Tulkki ei vastannut/saapunut',
    sv:	'Tolken svarade inte/anlände inte.',
    no:	'Tolken svarte ikke/kom ikke.',
    da:	'Tolken svarede ikke/ankom ikke.',
    fr:	'L\'interprète n\'a pas répondu/n\'est pas arrivé.'
  },
  'feedback:improvement:prebooking:2:interpretation:interpreter_was_late': {
    en: 'Interpreter was late',
    fi:	'Tulkki oli myöhässä',
    sv:	'Tolken var sen.',
    no:	'Tolken var forsinket.',
    da:	'Tolken var forsinket.',
    fr:	'L\'interprète était en retard.'
  },
  'feedback:improvement:prebooking:3:interpretation:interpreter_gave_unsolicited_advice_or_guidance': {
    en: 'Interpreter gave unsolicited advice or guidance',
    fi:	'Tulkki antoi pyytämättä neuvoja tai ohjausta',
    sv:	'Tolken gav oombedda råd eller vägledning',
    no:	'Tolken ga uoppfordret råd eller veiledning',
    da:	'Tolken gav uopfordret råd eller vejledning',
    fr:	'L\'interprète a donné des conseils ou des orientations non sollicités'
  },
  'feedback:improvement:ai:1:tech:accuracy': {
    en: 'Accuracy of interpretation',
    fi:	'Tarkkuus ja oikeellisuus',
    sv:	'Noggrannhet i tolkningen',
    no:	'Nøyaktighet på tolkningen',	
    da: 'Nøjagtighed af tolkningen',	
    fr: 'Exactitude de l\'interprétation'
  },
  'feedback:improvement:ai:2:tech:context': {
    en: 'Context understanding',
    fi: 'Kontekstin ymmärrys',
    sv:	'Förståelse av kontext',
    no:	'Forståelse av kontekst',
    da:	'Forståelse af kontekst',
    fr:	'Compréhension du contexte'
  },
  'feedback:improvement:ai:3:tech:terminology': {
    en: 'Terminology consistency and understanding',
    fi:	'Johdonmukaisuus ja termien yhtenäisyys',
    sv:	'Terminologins konsistens och förståelse',
    no:	'Terminologiens konsistens og forståelse',
    da:	'Terminologiens konsistens og forståelse',
    fr:	'Cohérence et compréhension de la terminologie'
  },
  'feedback:improvement:ai:4:interpretation:ui_clarity': {
    en: 'User interface clarity',
    fi:	'Käyttöliittymän selkeys',
    sv:	'Tydlighet i användargränssnittet',
    no:	'Klarhet i brukergrensesnittet',
    da:	'Klarhed i brugergrænsefladen',
    fr:	'Clarté de l\'interface utilisateur'
  },
  'feedback:improvement:ai:5:interpretation:response_time': {
    en: 'Response time',
    fi:	'Vastausaika',
    sv:	'Svarstid',
    no:	'Svarstid',
    da:	'Svar tid',
    fr:	'Temps de réponse'
  },
  'feedback:improvement:ai:6:interpretation:logic': {
    en: 'Logic and intuitiveness of functions',
    fi:	'Käytön logiikka ja intuitiivisuus',
    sv:	'Logik och intuitivitet i funktioner',
    no:	'Logikk og intuitivitet i funksjoner',	
    da: 'Logik og intuitivitet i funktioner',
    fr:	'Logique et intuitivité des fonctions'
  }
};

export const getFeedbackImprovements = (isAi, lang) => {
  const keys = Object.keys(improvements).filter(key => {
    if (isAi) {
      return key.includes(':ai:');
    } else {
      return key.includes(':prebooking:') || (key.includes(':tech:') && !key.includes(':ai:'));
    }
  });

  let langTag = 'en';
  if (lang && tulkaLanguages.includes(lang)) {
    langTag = lang;
  }

  return keys.reduce((acc, key) => {
    acc.push({ key, value: improvements[key][langTag] });
    return acc;
  }, []);
};
